"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.otrAddressToNetwork = exports.OtrRequest = exports.DatasetClass = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const uuid_1 = require("uuid");
class DatasetClass {
    constructor(otrAddress) {
        this.otrAddress = otrAddress;
    }
}
exports.DatasetClass = DatasetClass;
/**
 * OTR Request base class.
 *
 */
class OtrRequest {
    constructor(otrAddress, metadata, amount, nativeToken) {
        this.otrAddress = otrAddress;
        this.metadata = metadata;
        this.amount = amount;
        this.nativeToken = nativeToken;
        /**
         * Prepare required metadata based on your request to be sent to Tangle.
         *
         * @returns
         */
        this.getMetadata = () => ({
            targetAddress: this.otrAddress,
            metadata: { request: this.metadata },
            nativeToken: this.nativeToken,
            tag: this.generateTag(),
            amount: this.amount,
        });
        /**
         * Get Firefly deeplink with required data to submit request via tangle.
         *
         * @returns
         */
        this.getFireflyDeepLink = () => {
            const { metadata, nativeToken, tag } = this.getMetadata();
            const walletType = getFireflyWalletType(this.otrAddress);
            return (walletType +
                `://wallet/sendConfirmation?address=${this.otrAddress}` +
                '&disableToggleGift=true&disableChangeExpiration=true' +
                `&amount=${nativeToken ? nativeToken.amount : this.amount || 0}` +
                `&tag=${tag}&giftStorageDeposit=true` +
                `&metadata=${JSON.stringify(metadata)}` +
                (nativeToken ? `&assetId=${nativeToken === null || nativeToken === void 0 ? void 0 : nativeToken.id}` : ''));
        };
        /**
         * Get Bloom deeplink with required data to submit request via tangle.
         *
         * @returns
         */
        this.getBloomDeepLink = () => {
            const { metadata, nativeToken, tag, amount } = this.getMetadata();
            const parameters = {
                address: this.otrAddress,
                baseCoinAmount: Number(amount || 0).toFixed(0),
                tokenId: nativeToken === null || nativeToken === void 0 ? void 0 : nativeToken.id,
                tokenAmount: nativeToken ? Number(nativeToken.amount).toFixed(0) : undefined,
                tag,
                giftStorageDeposit: true,
                disableToggleGift: true,
                disableChangeExpiration: true,
                disableChangeTimelock: true,
                metadata: JSON.stringify(metadata),
            };
            const searchParams = Object.entries(parameters)
                .filter((e) => e[1] !== undefined)
                .map((e) => `${e[0]}=${e[1]}`)
                .join('&');
            return `bloom://wallet/sendTransaction?${searchParams}`;
        };
        /**
         * Generate unique tag to be able to track OTR progress via {@link ProjectWrapper.trackByTag}
         *
         * @returns
         */
        this.generateTag = () => (0, uuid_1.v4)().replace(/-/g, '');
        /**
         * Get tag that was generated for the OTR request.
         *
         * @param deeplink
         * @returns
         */
        this.getTag = (deeplink) => {
            const search = 'tag=';
            const startIndex = deeplink.indexOf(search);
            const endIndex = deeplink.indexOf('&', startIndex + search.length);
            if (startIndex === -1 || endIndex === -1 || endIndex <= startIndex) {
                return '';
            }
            return deeplink.substring(startIndex + search.length, endIndex);
        };
    }
}
exports.OtrRequest = OtrRequest;
/**
 * Detect wallet type based on the address.
 *
 * @param otrAddress
 * @returns
 */
const getFireflyWalletType = (otrAddress) => {
    if (otrAddress.startsWith(interfaces_1.Network.SMR) || otrAddress.startsWith(interfaces_1.Network.RMS)) {
        return 'firefly';
    }
    if (otrAddress.startsWith(interfaces_1.Network.IOTA)) {
        return 'iota';
    }
    throw Error('Invalid otr address, ono firefly wallet type found');
};
/**
 * Detect {@link Network} based on the address
 *
 * @param address
 * @returns
 */
const otrAddressToNetwork = (address) => {
    for (const network of Object.values(interfaces_1.Network)) {
        if (address.startsWith(network)) {
            return network;
        }
    }
    throw Error('Invalid otr address');
};
exports.otrAddressToNetwork = otrAddressToNetwork;
